import React, {
	Component
} from 'react';
import styled from 'styled-components';
import { store } from '../stores/mainStore';
import { i18n } from '../i18n';
import { comm } from '../comm';

const config = window.dodConfig;

const LanguagePage = styled.div`
	/* margin-top: 35%; */
	box-sizing: border-box;
	width: 100%;
	height: 100%;
	background: rgba(0,0,0, 0.75);
	display: flex;
	justify-content: center;
	align-items: center;
	color: white;
	font-size: 32px;
	pointer-events: auto;
`

const Content = styled.div`
	display: flex;
	width: 100%;
	height: 100%;
	padding-top: ${p => config.isLandscape ? 50 : 100}px;
	box-sizing: border-box;
	background-size: 100% auto;
	text-align: center;
	flex-direction: column;
`

const CloseBox = styled.div`
	position: relative;
	display: inline-block;
	width: 90vw;
	height: 94vw;
	margin: 0 auto;
	background-size: contain;
	background-repeat: no-repeat;
`

const CloseButton = styled.img`
	width: 12%;
	position: absolute;
	top: 4vw;
	right: -1vw;
`

const LanguageButtons = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	margin-top: 23vw;
`

const LButton = styled.img`
	width: 48vw;
	margin-bottom: 1vw;
`

function LanguageButton({lang, active}){
	return (
		<LButton onClick={() => {
			window.manager.playAudio("poopPop");
			i18n.changeLanguage(lang).then(() => {
				window.manager.resetToWaiting()
				store.modal = '';
				store.changeSetting('language', lang);
				window.manager.sceneRestarting = false;
				store.phaserInstanceIndex++;
				comm.SetUserLanguage();
				// window.WrapperApp.postMessage("restart-game");
				if(store.activeMatch){
					setTimeout(() => {
						manager.startGame();
					}, 1000);
				}
			});
		}} src={`/assets/popups/popup_btn_${lang}_${active ? 'on' : 'off'}.png`}/>
	)
}

export class ModalLanguage extends Component {

	close(){
		window.manager.playAudio("poopPop");
		store.modal = '';
	}

	render() {
		return (
			<LanguagePage>
				<Content>
					<CloseBox style={{
						backgroundImage: `url('/assets/languages/${store.settings.language}/popup_language.png')`
					}}>
						<CloseButton src="/assets/btn_close.png" onClick={e => this.close()}/>
						<LanguageButtons>
							{['en','fr','de','es','it'].map((l) => (
								<LanguageButton key={l} lang={l} active={l === store.settings.language}/>
							))}
						</LanguageButtons>
					</CloseBox>
				</Content>
			</LanguagePage>
		);
	}
}
